import { Component, Input } from '@angular/core';
import { fadeInOut } from '@shared/animations/animations';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { toastAnim, ToastPreset, toastPresets } from './toast-vars';

@Component({
  selector: '[success-toast]',
  styleUrls: ['./toast-styles.scss'],
  template: `
    <div class="custom-toast shadow-xl flex items-start mb-2.5 large-toast">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM14.7571 8.23016C15.0568 7.94425 15.068 7.4695 14.7821 7.1698C14.4962 6.87009 14.0214 6.85892 13.7217 7.14484L8.58387 12.0464L6.27842 9.84319C5.97896 9.55702 5.50421 9.56779 5.21803 9.86725C4.93186 10.1667 4.94263 10.6415 5.24209 10.9276L8.06527 13.6256C8.35499 13.9024 8.81118 13.9026 9.10114 13.626L14.7571 8.23016Z"
          fill="#6DC967"
        />
      </svg>

      <div class="grow success-text" style="overflow: hidden">
        <p *ngIf="message">{{ message }}</p>
      </div>

      <ng-container *ngIf="files?.length">
        <span
          class="flex flex-row items-center justify-center gap-2 download-btn cursor-pointer"
          (click)="showCalendarOptions($event)"
          *ngIf="hideICSOptions || false; else showICSOptionsTpl"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.84726 2.36985C1.84726 2.36985 1.84637 2.37226 1.84637 2.3751V12.6529C1.84637 12.6557 1.84726 12.6581 1.84726 12.6581C1.84781 12.6594 1.84882 12.6611 1.85044 12.6627C1.85206 12.6643 1.85371 12.6653 1.85501 12.6659C1.85501 12.6659 1.85742 12.6668 1.86026 12.6668H12.138C12.1409 12.6668 12.1433 12.6659 12.1433 12.6659C12.1446 12.6653 12.1462 12.6643 12.1479 12.6627C12.1495 12.6611 12.1505 12.6594 12.151 12.6581C12.151 12.6581 12.1519 12.6557 12.1519 12.6529V2.3751C12.1519 2.37226 12.151 2.36985 12.151 2.36985C12.1505 2.36855 12.1495 2.3669 12.1479 2.36528C12.1462 2.36366 12.1446 2.36265 12.1433 2.3621C12.1433 2.3621 12.1409 2.36121 12.138 2.36121H4.41588V1.36121H3.41588V2.36121H1.86026C1.85742 2.36121 1.85501 2.3621 1.85501 2.3621C1.85371 2.36265 1.85206 2.36366 1.85044 2.36528C1.84882 2.3669 1.84781 2.36855 1.84726 2.36985ZM0.846375 2.3751C0.846375 1.81515 1.30031 1.36121 1.86026 1.36121C1.86026 1.36121 2.80837 1.36121 3.41588 1.36121C6.82209 1.36121 12.138 1.36121 12.138 1.36121C12.698 1.36121 13.1519 1.81515 13.1519 2.3751V12.6529C13.1519 13.2128 12.698 13.6668 12.138 13.6668H1.86026C1.30031 13.6668 0.846375 13.2128 0.846375 12.6529V2.3751Z"
              fill="#FFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.91588 0.333374C4.19202 0.333374 4.41588 0.557232 4.41588 0.833375V2.36121V2.88893C4.41588 3.16508 4.19202 3.38893 3.91588 3.38893C3.63974 3.38893 3.41588 3.16508 3.41588 2.88893V2.36121V1.36121C3.41588 1.15508 3.41588 0.833375 3.41588 0.833375C3.41588 0.557232 3.63974 0.333374 3.91588 0.333374Z"
              fill="#FFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.84637 4.44455H12.1519C12.1519 4.72069 12.1519 5.44455 12.1519 5.44455H1.84637C1.84637 5.44455 1.84637 4.72069 1.84637 4.44455Z"
              fill="#FFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.00131 0.337118C7.27745 0.337118 7.50131 0.560975 7.50131 0.837118V2.36496V2.89268C7.50131 3.16882 7.27745 3.39268 7.00131 3.39268C6.72516 3.39268 6.50131 3.16882 6.50131 2.89268V2.36496H7.50131V1.36121L6.50131 1.36496C6.50131 1.15882 6.50131 0.837118 6.50131 0.837118C6.50131 0.560975 6.72516 0.337118 7.00131 0.337118Z"
              fill="#FFF"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.1226 0.337117C10.3987 0.337117 10.6226 0.560975 10.6226 0.837118V2.36496V2.89268C10.6226 3.16882 10.3987 3.39268 10.1226 3.39268C9.84645 3.39268 9.6226 3.16882 9.6226 2.89268V2.36496H10.6226V1.36121L9.6226 1.36496C9.6226 1.15882 9.6226 0.837118 9.6226 0.837118C9.6226 0.560975 9.84645 0.337117 10.1226 0.337117Z"
              fill="#FFF"
            />
            <path
              d="M3.27997 7.27447C3.27997 6.9513 3.54194 6.68933 3.8651 6.68933C4.18826 6.68933 4.45023 6.9513 4.45023 7.27447C4.45023 7.59763 4.18826 7.8596 3.8651 7.8596C3.54194 7.8596 3.27997 7.59763 3.27997 7.27447Z"
              fill="#FFF"
            />
            <path
              d="M6.4258 7.27447C6.4258 6.9513 6.68777 6.68933 7.01093 6.68933C7.33409 6.68933 7.59607 6.9513 7.59607 7.27447C7.59607 7.59763 7.33409 7.8596 7.01093 7.8596C6.68777 7.8596 6.4258 7.59763 6.4258 7.27447Z"
              fill="#FFF"
            />
            <path
              d="M9.54679 7.27447C9.54679 6.9513 9.80876 6.68933 10.1319 6.68933C10.4551 6.68933 10.7171 6.9513 10.7171 7.27447C10.7171 7.59763 10.4551 7.8596 10.1319 7.8596C9.80876 7.8596 9.54679 7.59763 9.54679 7.27447Z"
              fill="#FFF"
            />
            <path
              d="M3.27997 10.4742C3.27997 10.151 3.54194 9.88904 3.8651 9.88904C4.18826 9.88904 4.45024 10.151 4.45024 10.4742C4.45024 10.7973 4.18826 11.0593 3.8651 11.0593C3.54194 11.0593 3.27997 10.7973 3.27997 10.4742Z"
              fill="#FFF"
            />
            <path
              d="M6.4258 10.4742C6.4258 10.151 6.68778 9.88903 7.01094 9.88903C7.3341 9.88903 7.59607 10.151 7.59607 10.4742C7.59607 10.7973 7.3341 11.0593 7.01094 11.0593C6.68778 11.0593 6.4258 10.7973 6.4258 10.4742Z"
              fill="#FFF"
            />
          </svg>
          <span>
            {{ 'GLOBAL.ADD_TO_CALENDAR' | transloco | capitalize }}
          </span>
        </span>

        <ng-template #showICSOptionsTpl>
          <span
            *ngFor="let file of files"
            class="flex flex-row items-center justify-center gap-2 download-btn cursor-pointer h-8-5"
          >
            <a
              target="_blank"
              class="w-full flex flex-row items-center justify-start gap-2"
              [href]="file.url"
              [download]="file.fileName"
              (click)="close($event)"
              @fadeInOut
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="20px"
                viewBox="0 -960 960 960"
                width="20px"
                fill="#FFF"
              >
                <path
                  d="M680-80v-120H560v-80h120v-120h80v120h120v80H760v120h-80Zm-480-80q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h40v-80h80v80h240v-80h80v80h40q33 0 56.5 23.5T760-720v244q-20-3-40-3t-40 3v-84H200v320h280q0 20 3 40t11 40H200Zm0-480h480v-80H200v80Zm0 0v-80 80Z"
                />
              </svg>
              <span>
                {{ 'GLOBAL.ADD_TO_CALENDAR' | transloco | capitalize }}
              </span>
              <!-- <span>
                {{
                  'GLOBAL.ICS.' +
                    (file.target ? file.target.toUpperCase() : 'DEFAULT')
                    | transloco
                }}
              </span> -->
            </a>
          </span>
        </ng-template>
      </ng-container>

      <div (click)="close($event)" class="cursor-pointer">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M20.0303 5.03033C20.3232 4.73744 20.3232 4.26256 20.0303 3.96967C19.7374 3.67678 19.2626 3.67678 18.9697 3.96967L12 10.9393L5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L10.9393 12L3.96967 18.9697C3.67678 19.2626 3.67678 19.7374 3.96967 20.0303C4.26256 20.3232 4.73744 20.3232 5.03033 20.0303L12 13.0607L18.9697 20.0303C19.2626 20.3232 19.7374 20.3232 20.0303 20.0303C20.3232 19.7374 20.3232 19.2626 20.0303 18.9697L13.0607 12L20.0303 5.03033Z"
            fill="white"
          />
        </svg>
      </div>
    </div>
  `,
  animations: [toastAnim, fadeInOut],
})
export class ICSToastComponent extends Toast {
  @Input() toastId: number;
  @Input() icon: string;

  @Input() files?: Array<{
    url: string;
    fileName?: string;
    target?: 'google' | 'outlook' | 'default';
  }> = [];
  successPresets: ToastPreset;
  hideICSOptions = false;

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage,
  ) {
    super(toastrService, toastPackage);
    this.successPresets = toastPresets.success;
    this.disableTimeOut();
  }

  close(event?: any): void {
    event.stopPropagation();
    this.toastrService.remove(this.toastId);
  }

  disableTimeOut() {
    this.options.timeOut = 0;
    this.options.extendedTimeOut = 0;
    this.resetTimeout();
  }

  showCalendarOptions(event: any) {
    // event.stopPropagation();
    // this.hideICSOptions = !this.hideICSOptions;
  }
}
